import React from "react";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Label } from "./ui/label";
import { Workout } from "../schemas/workout";

interface WorkoutDetailsProps {
  workout: Workout;
  handleNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleDescriptionChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

export function WorkoutDetails({
  workout,
  handleNameChange,
  handleDescriptionChange,
}: WorkoutDetailsProps) {
  return (
    <div className="space-y-4 mb-8">
      <div className="space-y-2">
        <Label htmlFor="name">Name</Label>
        <Input
          id="name"
          value={workout.name}
          onChange={handleNameChange}
          placeholder="Enter workout name"
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="description">Description</Label>
        <Textarea
          id="description"
          value={workout.description || ""}
          onChange={handleDescriptionChange}
          placeholder="Enter workout description (optional)"
          rows={3}
        />
      </div>
    </div>
  );
}
